import {db} from './db';
import {getAuthToken} from './auth';
import {guestRequest} from './guestApi';
import type {GuestFarm} from './guestApi';
import {JournalPolicy,JournalRepository} from './journalRepository';
import {PhotoOutbox} from './photoOutbox';
import {PhotoMediaCache} from './photoMediaCache';
export * from './journalRepository';
let policy:JournalPolicy={scope:'signed-out',account:'',active:false,farms:[],canComment:false,canUpload:false,name:''};
const repositories=new WeakMap<typeof db,JournalRepository>();
const uploads=new WeakMap<typeof db,PhotoOutbox>();
const media=new WeakMap<typeof db,PhotoMediaCache>();
export const setJournalPolicy=(next:JournalPolicy)=>{policy=next;};
const notify=()=>window.dispatchEvent(new Event('sonata-journal-updated'));
const notifyPurge=()=>{window.dispatchEvent(new Event('sonata-photo-cache-purged'));notify();};
const accountRequest=async<T>(database:typeof db,path:string,method='GET',body?:unknown)=>{
 const token=getAuthToken(),result=await guestRequest<T>(path,method,body);
 if(db!==database||token!==getAuthToken())throw new Error('Account changed.');return result;
};
export function photoJournal(){
 const database=db,account=policy.account;
 if(!repositories.has(database))repositories.set(database,new JournalRepository(database,<T>(path:string,method='GET',body?:unknown)=>accountRequest<T>(database,path,method,body),()=>policy,()=>db===database&&policy.account===account,()=>navigator.onLine,()=>Date.now(),notifyPurge));
 return repositories.get(database)!;
}
export function photoUploads(){
 const database=db,account=policy.account;
 if(!uploads.has(database))uploads.set(database,new PhotoOutbox(database,<T>(path:string,method='GET',body?:unknown)=>accountRequest<T>(database,path,method,body),()=>policy,()=>db===database&&policy.account===account,()=>navigator.onLine,notify));
 return uploads.get(database)!;
}
export function photoMediaCache(){
 const database=db,account=policy.account;
 if(!media.has(database))media.set(database,new PhotoMediaCache(database,()=>policy,()=>db===database&&policy.account===account,()=>photoJournal().purge()));
 return media.get(database)!;
}
export async function flushPhotoJournal(){await photoUploads().flush();await photoJournal().flush();}
export async function journalPhoto(id:string,audience:'work'|'nature'|'auto'='auto'){
 const database=db,outbox=photoUploads(),queued=(await outbox.all()).find(p=>p.photo_id===id);
 if(database!==db)throw new Error('Account changed.');
 if(queued&&(audience==='auto'||queued.audience===audience))return outbox.preview(queued);
 return photoJournal().photo(id,audience);
}
export async function journalFarm(){
 const database=db,scope=policy.scope;
 let farms:GuestFarm[]=(await database.workspaceMeta.get('guest-farms'))?.value||[];
 if(navigator.onLine){
  try{farms=await guestRequest<GuestFarm[]>('/guest/farms');}
  catch(e){const status=(e as any).status||0;if((status>=400&&status<500)||!farms.length)throw e;}
 }
 if(database!==db||scope!==policy.scope)throw new Error('Account changed.');
 const farm=farms.find(f=>policy.admin||policy.farms.includes(f.farm_id));
 if(!farm)throw new Error('Property access is required.');return farm;
}
